import React, { Component } from 'react'
import styled from 'styled-components'
import { OnSiteLink, UL, Link } from 'atoms'
import { ConfigConsumer } from 'contexts/config-context'
import Submenu from '../Submenu'

const StyledLink = styled(Link)`
  color: #fff;
  padding: 16px;
  display: inline-block;
  cursor: pointer;

  &:visited,
  &:hover,
  &:link {
    color: #fff;
  }
`

const MainNavLink = styled(OnSiteLink)`
  color: #fff;
  padding: 16px;
  display: inline-block;
  cursor: pointer;

  &:visited,
  &:hover,
  &:link {
    color: #fff;
  }
`

const ItemsList = UL.extend`
  list-style-type: none;
  margin: 0 0 0 16px;

  &:hover a {
    opacity: 0.6;
  }

  .is-expanded a,
  a:hover {
    opacity: 1;
  }
`

const NavItem = styled.li`
  display: inline-block;
  padding: 0;

  .Collapsible {
    border-bottom: 1px solid #e2e2e2;

    a {
      cursor: pointer;
    }

    .Collapsible__contentInner > div {
      border-bottom: none;
    }
  }
`

class MainNavItems extends Component {
  render() {
    return (
      <ConfigConsumer>
        {(config) => (
          <ItemsList>
            {config.navItems.map((navItem, index) => {
              return (
                <NavItem key={`MainNavItem-${index}-${navItem.text}`}>
                  {navItem.subItems !== undefined ? (
                    <Submenu items={navItem.subItems} onSiteLink={true}>
                      <StyledLink href={navItem.url} data={navItem.data}>
                        {navItem.text}
                      </StyledLink>
                    </Submenu>
                  ) : (
                    <MainNavLink href={navItem.url} data={navItem.data}>
                      {navItem.text}
                    </MainNavLink>
                  )}
                </NavItem>
              )
            })}
          </ItemsList>
        )}
      </ConfigConsumer>
    )
  }
}

export default MainNavItems



// WEBPACK FOOTER //
// ./src/molecules/MainNavItems/MainNavItems.js